import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ConfigProvider from 'antd/es/config-provider';
import { App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// 面向答题用户的页面直接打进主包，保证首屏最快
import Home from './pages/Home';
import Test from './pages/Test';
import Result from './pages/Result';
import Login from './pages/Login';
import Register from './pages/Register';

// 后台页面按需加载：这些都在登录之后才用得到，
// 打进主包会让手机上答题的用户白白下载一堆用不上的代码
const Admin = lazy(() => import('./pages/Admin'));
const Profile = lazy(() => import('./pages/Profile'));
const PointsManagement = lazy(() => import('./pages/PointsManagement'));
const ErrorLogs = lazy(() => import('./pages/ErrorLogs'));
const BatchGenerate = lazy(() => import('./pages/BatchGenerate'));
const ActivationCodeManagement = lazy(() => import('./pages/ActivationCodeManagement'));
const ActivationCode = lazy(() => import('./pages/ActivationCode'));

const PageLoading = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#666',
    fontSize: 16
  }}>
    加载中...
  </div>
);

function App() {
  return (
    <ConfigProvider 
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <AntdApp>
        <AuthProvider>
          <Router>
            <div className="App">
              <Suspense fallback={<PageLoading />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/test/scl-90/:testId" element={<Test />} />
                <Route path="/test/scl-90/:testId/result" element={<Result />} />

                {/* <Route 
                  path="/Admin" 
                  element={
          
                      <Admin />
 
                  } 
                /> */}
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/Admin" 
                  element={
                    <ProtectedRoute>
                      <Admin />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/batch-generate" 
                  element={
                    <ProtectedRoute>
                      <BatchGenerate />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/points-management" 
                  element={
                    <ProtectedRoute>
                      <PointsManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/error-logs" 
                  element={
                    <ProtectedRoute>
                      <ErrorLogs />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/activation-codes" 
                  element={
                    <ProtectedRoute>
                      <ActivationCodeManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/activation-code" 
                  element={
                    <ProtectedRoute>
                      <ActivationCode />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
              </Suspense>
            </div>
          </Router>
        </AuthProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
